/**
 * description: 描述信息
 * author: bql
 * 2023/8/14 14:45
 */
import { Methods } from "@newview/infrastructure";
import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class EmployeeDepartureJoinApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'employee-departure-join'
    }

}